import {cs}          from "../../react/chain-services";
import {AlertModal} from "../../ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";

export const NotifyReset = ({next}) => cs(
    ["dialogAlertReset", ({}, next) => AlertModal({next})],
    ({dialogAlertReset}) => next(async () => {
        await dialogAlertReset.show({
            message: "Template Reset",
            description: "This template has been updated. The customization has been lost.",
        });
    }),
);
